module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#gallery",
      toString: function () {
        return this.url;
      }
    }